// Common response interfaces
export interface ApiResponse<T> {
  success: boolean;
  result: T;
  message?: string;
}

/**
 * Generic API request handler
 */

export async function apiRequest<T>(
  url: string,
  options: RequestInit,
  errorMessage: string = "API request failed"
): Promise<T> {
  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(`${errorMessage}: ${response.status} - ${errorData.message || response.statusText}`);
    }

    const data = await response.json() as ApiResponse<T>;

    if (!data.success) {
      throw new Error(data.message || errorMessage);
    }

    return data.result;
  } catch (error) {
    console.error(errorMessage, error instanceof Error ? error.message : String(error));
    throw error;
  }
}